import { createContext, useContext, useEffect, useState } from "react";
import { getContent, updateContent } from "../lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [map, setMap] = useState({});
  useEffect(() => { getContent().then(setMap).catch(() => {}); }, []);

  const get = (key, fallback = "") => (map[key] !== undefined && map[key] !== "" ? map[key] : fallback);
  const save = async (key, value) => {
    await updateContent(key, value);
    setMap((m) => ({ ...m, [key]: value }));
  };

  return <ContentContext.Provider value={{ get, save }}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
